import React from "react";
import { useNavigate } from "react-router-dom";

import "./Dashboard.css";      // ✅ Core dashboard layout + hero
import "./SherlocHub.css";     // Card styles

import CphereHeaderLogo from "../components/CphereHeaderLogo";

// Card images for client cards
import crossPlatformIntelligence from "../assets/crossplatformintelligence.gif";
import aiOptimizationsGif from "../assets/aioptimizations.gif";
import cphereHero from "../assets/cphere.png";               // HERO IMAGE FOR MEDIA PLANNER
import mediaPlannerHero from "../assets/mediacampaigns.jpg"; // HERO IMAGE FOR MEDIA CAMPAIGNS

const SherlocHubClient = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => navigate("/dashboard");

  return (
    <div className="core-dashboard sherlochub-page">
      <div className="core-dashboard-content">
        {/* Shared Cphere header logo – preserve existing dashboard spacing */}
        <CphereHeaderLogo
          alt="Cphere"
          className="core-poweredby-logo"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        />

        {/* 🔹 Core hero pill + shimmer bar (same system as Dashboard / Billing / Install App) */}
        <div className="core-hero-container">
          <div className="core-hero-pill">
            <span className="core-hero-pill-label cphere-hero-pill-wordmark">Sherloc</span>
            <span className="core-hero-pill-tag cphere-hero-pill-tag">Agentic</span>
          </div>
          <div className="core-hero-shimmer-bar" />
        </div>

        {/* Cards Wrapper – design unchanged */}
        <div className="sherlochub-cards-wrapper">
          {/* ====================================================== */}
          {/* CARD 1 – SHERLOC MEDIA PLANNER (CLIENT)               */}
          {/* ====================================================== */}
          <div className="sherlochub-card">
            <div className="sherlochub-beta-tag">Agentic</div>

            <div>
              <div className="sherloc-card-header">
                <div className="sherloc-card-icon-wrapper">
                  <img
                    src={cphereHero}
                    alt="Sherloc Media Planner"
                    className="sherloc-card-icon"
                  />
                </div>
                <h2 className="sherlochub-card-title">Plan</h2>
              </div>

              <p className="sherlochub-card-text">
                Submit an RFP to Sherloc AI for a cross platform media strategy.
              </p>
            </div>

            <button
              className="optimization-save-button sherlochub-card-button shimmer-button"
              onClick={() => navigate("/sherloc-media-planner")}
            >
              Open Planner
            </button>
          </div>

          {/* ====================================================== */}
          {/* CARD 1B – SHERLOC MEDIA CAMPAIGNS (CLIENT)            */}
          {/* ====================================================== */}
          <div className="sherlochub-card">
            <div className="sherlochub-beta-tag">Agentic</div>

            <div>
              <div className="sherloc-card-header">
                <div className="sherloc-card-icon-wrapper">
                  <img
                    src={mediaPlannerHero}
                    alt="Sherloc Media Campaigns"
                    className="sherloc-card-icon"
                  />
                </div>
                <h2 className="sherlochub-card-title">Campaigns</h2>
              </div>

              <p className="sherlochub-card-text">
                View your Sherloc Media Planner runs, approvals, and upcoming
                campaign flights in one place.
              </p>
            </div>

            <button
              className="optimization-save-button sherlochub-card-button shimmer-button"
              onClick={() => navigate("/sherloc-media-campaigns")}
            >
              View Campaigns
            </button>
          </div>

          {/* ====================================================== */}
          {/* CARD 2 – CROSS PLATFORM INTELLIGENCE                  */}
          {/* ====================================================== */}
          <div className="sherlochub-card">
            <div>
              <div className="sherloc-card-header">
                <div className="sherloc-card-icon-wrapper">
                  <img
                    src={crossPlatformIntelligence}
                    alt="Cross Platform Intelligence"
                    className="sherloc-card-icon"
                  />
                </div>
                <h2 className="sherlochub-card-title">Insights</h2>
              </div>

              <p className="sherlochub-card-text">
                AI-structured insights in one unified intelligence workspace.
              </p>
            </div>

            <button
              className="optimization-save-button sherlochub-card-button shimmer-button"
              onClick={() => navigate("/ai-optimizations")}
            >
              View Insights
            </button>
          </div>

          {/* ====================================================== */}
          {/* CARD 3 – AGENTIC AI ANALYSIS                          */}
          {/* ====================================================== */}
          <div className="sherlochub-card">
            <div className="sherlochub-beta-tag">Agentic</div>

            <div>
              <div className="sherloc-card-header">
                <div className="sherloc-card-icon-wrapper">
                  <img
                    src={aiOptimizationsGif}
                    alt="Agentic AI"
                    className="sherloc-card-icon"
                  />
                </div>
                <h2 className="sherlochub-card-title">Analysis</h2>
              </div>

              <p className="sherlochub-card-text">
                Agentic AI-enabled cross platform campaign analysis.
              </p>
            </div>

            <button
              className="optimization-save-button sherlochub-card-button shimmer-button"
              onClick={() => navigate("/sherloc-reports")}
            >
              Agentic Analysis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SherlocHubClient;
